export default __webpack_public_path__ + "static/media/14.bf26149f.jpg";